import { render, staticRenderFns } from "./menuBackground.vue?vue&type=template&id=1369feda&scoped=true"
import script from "./menuBackground.vue?vue&type=script&lang=js"
export * from "./menuBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369feda",
  null
  
)

export default component.exports